import "jquery-countdown";
import moment from "moment";

window.onload = () => {
  const $sliderCountdown = $("#countdown-slide_target");
  const $sliderCountdownBBO = $("#countdown-slide_target-bbo");
  const $sliderCountdownBTCHome = $("#countdown-btc-slide_target");
  if ($sliderCountdownBTCHome) {
    const startingDate = "2020-11-21";
    const futureDate = moment(startingDate, "YYYY-MM-DD")
      .add(1, "M")
      .format("YYYY-MM-DD");

    $sliderCountdown.countdown(futureDate, (event) => {
      $(event.currentTarget).html(
        event.strftime(
          "" +
            '<p class="count-btc-digits days">%-D<span>days</span></p>' +
            '<p class="count-btc-digits hours">%H<span>hours</span></p>' +
            '<p class="count-btc-digits mins">%M<span>minutes</span></p>' +
            '<p class="count-btc-digits secs">%S<span>seconds</span></p>'
        )
      );
    });
  }
  if ($sliderCountdownBBO) {
    const startingDate = "2021-02-04";
    const futureDate = moment(startingDate, "YYYY-MM-DD")
      .add(1, "M")
      .format("YYYY-MM-DD");
    $sliderCountdownBBO.countdown(futureDate, (event) => {
      $(event.currentTarget).html(
        event.strftime(
          "" +
            '<p class="count-digits">%-D<span>days</span></p>' +
            '<p class="count-digits">%H<span>hours</span></p>' +
            '<p class="count-digits">%M<span>minutes</span></p>' +
            '<p class="count-digits">%S<span>seconds</span></p>'
        )
      );
    });
  }
  if ($sliderCountdown) {
    const startingDate = "2020-11-21";
    const futureDate = moment(startingDate, "YYYY-MM-DD")
      .add(1, "M")
      .format("YYYY-MM-DD");

    $sliderCountdown.countdown(futureDate, (event) => {
      $(event.currentTarget).html(
        event.strftime(
          "" +
            '<p class="count-digits">%-D</p>' +
            '<p class="count-digits">%H/p>' +
            '<p class="count-digits">%M/p>' +
            '<p class="count-digits">%S</p>'
        )
      );
    });
  }
};
